// Iconos SVG de línea (estilo lucide: 24×24, trazo 2, currentColor).
// Inline para no cargar nada externo; heredan el color del tile (activo = blanco).

const svg = (inner: string): string =>
  `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${inner}</svg>`;

export const ICONS: Record<string, string> = {
  // ---- Perfiles ----
  motor: svg(
    '<path d="M9 11V6a1.5 1.5 0 0 1 3 0v4"/><path d="M12 10V5.5a1.5 1.5 0 0 1 3 0V10"/><path d="M15 10.5V7a1.5 1.5 0 0 1 3 0v7a6 6 0 0 1-6 6h-1a6 6 0 0 1-5-2.7L4 14.4a1.6 1.6 0 0 1 2.6-1.8L8 14"/>'
  ),
  blind: svg(
    '<path d="M2 12s3.5-6 10-6c1.2 0 2.3.2 3.3.5"/><path d="M22 12s-3.5 6-10 6c-1.2 0-2.3-.2-3.3-.5"/><circle cx="12" cy="12" r="2.5"/><line x1="4" y1="20" x2="20" y2="4"/>'
  ),
  colorblind: svg(
    '<circle cx="12" cy="12" r="9"/><path d="M12 3a9 9 0 0 0 0 18z" fill="currentColor" stroke="none"/>'
  ),
  dyslexia: svg(
    '<path d="M4 18 8 6l4 12"/><path d="M5.5 14h5"/><path d="M15 6h3a3 3 0 0 1 0 6h-3zM15 12h3.5a3 3 0 0 1 0 6H15z"/>'
  ),
  lowvision: svg(
    '<circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16" y2="16"/><path d="M8 11h6"/>'
  ),
  cognitive: svg(
    '<path d="M12 4a4 4 0 0 0-4 4 3.5 3.5 0 0 0-2 6.2A3.5 3.5 0 0 0 8.5 20H12z"/><path d="M12 4a4 4 0 0 1 4 4 3.5 3.5 0 0 1 2 6.2A3.5 3.5 0 0 1 15.5 20H12z"/>'
  ),
  epilepsy: svg(
    '<path d="M13 2 5 13h5l-1 9 8-11h-5z"/><line x1="3" y1="3" x2="21" y2="21"/>'
  ),
  adhd: svg(
    '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="1.5" fill="currentColor"/>'
  ),

  // ---- Navegación ----
  srMode: svg(
    '<path d="M7 9v6h3l4 4V5l-4 4z"/><path d="M17 9a4 4 0 0 1 0 6"/>'
  ),
  keyboardNav: svg(
    '<rect x="2" y="7" width="20" height="11" rx="2"/><path d="M6 11h.01M10 11h.01M14 11h.01M18 11h.01M6 14h.01M18 14h.01M9 14.5h6"/>'
  ),
  mousegrid: svg(
    '<rect x="3" y="3" width="18" height="18" rx="2"/><line x1="9" y1="3" x2="9" y2="21"/><line x1="15" y1="3" x2="15" y2="21"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="3" y1="15" x2="21" y2="15"/>'
  ),
  smartNav: svg(
    '<circle cx="12" cy="12" r="9"/><path d="m15.5 8.5-2 5-5 2 2-5z"/>'
  ),
  tts: svg(
    '<path d="M4 9v6h3l4 4V5L7 9z"/><path d="M15 8a5 5 0 0 1 0 8"/><path d="M17.5 5.5a8.5 8.5 0 0 1 0 13"/>'
  ),
  voice: svg(
    '<rect x="9" y="3" width="6" height="11" rx="3"/><path d="M5 11a7 7 0 0 0 14 0"/><line x1="12" y1="18" x2="12" y2="21"/>'
  ),

  // ---- Color ----
  mono: svg(
    '<circle cx="12" cy="12" r="9"/><path d="M12 3v18"/><path d="M12 3a9 9 0 0 1 0 18z" fill="currentColor" stroke="none"/>'
  ),
  darkhc: svg('<path d="M20 13A8 8 0 1 1 11 4a6.5 6.5 0 0 0 9 9z"/>'),
  brighthc: svg(
    '<circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/>'
  ),
  lowsat: svg(
    '<path d="M12 3s6 7 6 11a6 6 0 0 1-12 0c0-4 6-11 6-11z"/><path d="M8 15h8"/>'
  ),
  highsat: svg(
    '<path d="M12 3s6 7 6 11a6 6 0 0 1-12 0c0-4 6-11 6-11z"/><path d="M12 8v9M8.5 11.5 12 17l3.5-5.5" stroke-width="1.5"/>'
  ),
  contrastMode: svg(
    '<circle cx="12" cy="12" r="9"/><path d="M12 5a7 7 0 0 0 0 14z" fill="currentColor" stroke="none"/>'
  ),

  // ---- Contenido ----
  blinks: svg(
    '<path d="M13 2 5 13h5l-1 9 8-11h-5z"/><circle cx="12" cy="12" r="10" stroke-dasharray="3 3"/>'
  ),
  magnifier: svg(
    '<circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16" y2="16"/><path d="M11 8v6M8 11h6"/>'
  ),
  readableFont: svg(
    '<path d="M5 19 11 5l6 14"/><path d="M7.5 14h7"/><path d="M19 5v14"/>'
  ),
  imgDesc: svg(
    '<rect x="3" y="4" width="18" height="14" rx="2"/><circle cx="8.5" cy="9" r="1.5"/><path d="m21 14-4.5-4.5L9 17"/><path d="M7 21h10"/>'
  ),
  links: svg(
    '<path d="M10 14a5 5 0 0 0 7.5.5l2-2a5 5 0 0 0-7-7l-1 1"/><path d="M14 10a5 5 0 0 0-7.5-.5l-2 2a5 5 0 0 0 7 7l1-1"/>'
  ),
  readableMode: svg(
    '<path d="M6 3h9l4 4v14H6z"/><path d="M15 3v4h4"/><path d="M9 12h6M9 16h6"/>'
  ),
  textMag: svg(
    '<circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16" y2="16"/><path d="M9 13.5 11 8l2 5.5M9.7 12h2.6"/>'
  ),
  pageStructure: svg(
    '<path d="M4 5h16M4 12h10M4 19h13"/><circle cx="19" cy="12" r="1.2" fill="currentColor" stroke="none"/><circle cx="20.5" cy="19" r="1.2" fill="currentColor" stroke="none"/>'
  ),
  muteMedia: svg(
    '<path d="M4 9v6h3l4 4V5L7 9z"/><line x1="15" y1="9" x2="21" y2="15"/><line x1="21" y1="9" x2="15" y2="15"/>'
  ),
  pageSummary: svg(
    '<rect x="4" y="3" width="16" height="18" rx="2"/><path d="M8 7h8M8 11h8M8 15h5"/>'
  ),
  readFocus: svg(
    '<path d="M3 5h18M3 19h18" opacity=".4"/><rect x="3" y="9" width="18" height="6" rx="1"/>'
  ),
  readGuide: svg(
    '<path d="M3 12h18"/><path d="M6 9V6M12 9V5M18 9V6M6 18v-3M12 19v-4M18 18v-3"/>'
  ),
  dict: svg(
    '<path d="M12 6a4 4 0 0 0-4-2H3v15h5a4 4 0 0 1 4 2 4 4 0 0 1 4-2h5V4h-5a4 4 0 0 0-4 2z"/><path d="M12 6v15"/>'
  ),
  vkb: svg(
    '<rect x="2" y="7" width="20" height="11" rx="2"/><path d="M6 11h.01M10 11h.01M14 11h.01M18 11h.01M7 14.5h10"/>'
  ),

  easyRead: svg(
    '<path d="M12 6a4 4 0 0 0-4-2H3v15h5a4 4 0 0 1 4 2 4 4 0 0 1 4-2h5V4h-5a4 4 0 0 0-4 2z"/><path d="m17.5 8.5.6 1.4 1.4.6-1.4.6-.6 1.4-.6-1.4-1.4-.6 1.4-.6z" fill="currentColor" stroke="none"/>'
  ),

  // ---- Cabecera ----
  move: svg('<path d="M8 7 3 12l5 5"/><path d="M16 7l5 5-5 5"/>'),
  hide: svg(
    '<path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6-10-6-10-6z"/><circle cx="12" cy="12" r="2.5"/><line x1="4" y1="20" x2="20" y2="4"/>'
  ),
  close: svg('<line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/>'),
};

export function icon(name: string): string {
  return ICONS[name] ?? "";
}
